module.exports = __webpack_public_path__ + "static/media/brouver.e11a6e7f.png";